import React, { useRef, useEffect, useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { TweenMax, Power3, gsap } from 'gsap'
import PortableText from '@sanity/block-content-to-react'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const StudentInfo = styled.div`
  background: var(--light);
  margin: 0;
  box-sizing: border-box;
  padding-left: var(--left-margin);
  padding-top:33vh;
  font-family: var(--sans);
  /* padding-right:5vw; */

  ${media.medium}{
    padding-right:9vw;

  }

  h3{
    font-family:var(--sans);
    font-size:var(--small-text);
    text-transform:uppercase;
  }
  .artist-bio {
    /* min-height: 50vh; */
    font-size: var(--small-text);
    padding: 4em 0em;

    ${media.medium}{
      max-width:66%;
    }
    
    p {
      font-weight: 500;
      letter-spacing: 0.03em;
      line-height: 1.5;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }
  .thesis-download{
    font-size:var(--medium-text);
    font-weight:500;
    text-decoration:none;
    border-bottom:0.05em solid var(--black);
  }
  .artist-statement {
    box-sizing: border-box;
    font-size: var(--medium-text);
    margin: 0;
    font-family: var(--sans);
    font-weight:400;
    /* letter-spacing: -0.03em; */

    ${media.medium}{
      font-size: var(--large-text);
      /* max-width: 80%; */
    }
    ${media.large}{
      /* max-width:20em; */

    }

    ${media.large}{
      padding-right:18vw;
      font-variation-settings: 'wght' 400;
      /* letter-spacing:-0.05em; */
    }

    p {
      font-size:var(--large-text);

    }
    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
      margin: 0;
    }
  }
`

export default function NewBio ({ student }) {
  return (
    <StudentInfo>
      {student._rawArtistStatement &&
        <h3>Artist Statement</h3>
      }

      <PortableText
        className="artist-statement"
        blocks={student._rawArtistStatement}
      />

      {student.file &&
        <a className="thesis-download" href={student.file.asset.url}>Download an exceprt from {student.first_name}'s thesis</a>
      }

      <div className="artist-bio">
        <PortableText className="artist-bio" blocks={student._rawBio} />
      </div>
    </StudentInfo>

  )
}
